import React, { useState, useEffect } from 'react';
import { ArrowLeft, ScrollText } from 'lucide-react';
import api from '../../lib/api';

const CampusDecretos = ({ onBack }) => {
  const [decretos, setDecretos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchDecretos(); }, []);

  const fetchDecretos = async () => {
    try {
      const res = await api.get('/campus/decretos');
      setDecretos(res.data.decretos || []);
    } catch {}
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#faf8f4] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#c9a227] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#faf8f4]" data-testid="campus-decretos">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-[#5c4a2a]/30 hover:text-[#5c4a2a]/60 transition-colors text-sm mb-8"
          data-testid="decretos-back-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al jardín
        </button>

        <div className="text-center mb-10">
          <ScrollText className="w-8 h-8 text-[#c9a227]/50 mx-auto mb-3" />
          <h1 className="text-[#5c4a2a]/70 text-2xl font-light">Mis Decretos</h1>
          <p className="text-[#5c4a2a]/30 text-sm mt-2">Tu altar personal de palabras de poder</p>
        </div>

        {decretos.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-[#5c4a2a]/25 text-sm">
              Los decretos se desbloquean al leer el contenido del Campus.
            </p>
            <p className="text-[#5c4a2a]/18 text-xs mt-2">
              Cada lectura puede revelar un decreto para ti.
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {decretos.map((d, i) => (
              <div key={d.id} className="relative group" style={{ animationDelay: `${i * 100}ms` }}>
                <div className="absolute inset-0 bg-[#c9a227]/5 rounded-xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="relative bg-white border border-[#c9a227]/10 hover:border-[#c9a227]/25 rounded-xl p-6 transition-all">
                  <p className="text-[#8a6a20] text-lg font-light italic leading-relaxed text-center">
                    "{d.text}"
                  </p>
                  {d.unlocked_at && (
                    <p className="text-[#5c4a2a]/35 text-xs text-center mt-4">
                      Desbloqueado el {new Date(d.unlocked_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CampusDecretos;
